<template>
  <div class="arrow">
    <svg v-if="!downArrow" fill="#000000" fill-opacity="0.54" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
      <path d="M0-.75h24v24H0z" fill="none"/>
    </svg>

    <svg v-if="downArrow" fill="#000000" fill-opacity="0.54" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'KeyboardArrow',
  props: ['downArrow']
}
</script>

<style>
.arrow {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/KeyboardArrow.vue